import React, { createContext, useContext, useState, useEffect } from 'react';

// Authentication Context for Login System
const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const logout = React.useCallback(() => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
    setIsSubscribed(false);
  }, []);

  // Check if user is logged in on mount
  const checkAuthStatus = React.useCallback(async () => {
    try {
      // TODO: Replace with actual API call to your backend
      const token = localStorage.getItem('authToken');
      
      if (token) {
        // TODO: Validate token with backend
        // const response = await fetch('YOUR_API/auth/verify', {
        //   headers: { 'Authorization': `Bearer ${token}` }
        // });
        // const userData = await response.json();
        
        // For now, simulate logged in user
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          const userData = JSON.parse(storedUser);
          setUser(userData);
          setIsSubscribed(userData.isSubscribed || false);
        }
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      logout();
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    checkAuthStatus();
  }, [checkAuthStatus]);


  const login = async (email, password) => {
    try {
      // TODO: Replace with actual API call
      // const response = await fetch('YOUR_API/auth/login', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ email, password })
      // });
      // const data = await response.json();
      
      // Simulate successful login
      const userData = {
        id: '1',
        email: email,
        name: email.split('@')[0],
        isSubscribed: true,
        subscribedAt: new Date().toISOString()
      };
      
      const token = 'demo-token-' + Date.now();
      
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(userData));
      
      setUser(userData);
      setIsSubscribed(userData.isSubscribed);
      
      return { success: true, user: userData };
    } catch (error) {
      console.error('Login failed:', error);
      return { success: false, error: error.message };
    }
  };

  const signup = async (email, password, name) => {
    try {
      // TODO: Replace with actual API call
      // const response = await fetch('YOUR_API/auth/signup', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ email, password, name })
      // });
      // const data = await response.json();
      
      // Simulate successful signup
      const userData = {
        id: Date.now().toString(),
        email,
        name,
        isSubscribed: false, // Becomes true after subscribing
        createdAt: new Date().toISOString()
      };
      
      const token = 'demo-token-' + Date.now();
      
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(userData));
      
      setUser(userData);
      setIsSubscribed(false);
      
      return { success: true, user: userData };
    } catch (error) {
      console.error('Signup failed:', error);
      return { success: false, error: error.message };
    }
  };


  const subscribe = async () => {
    try {
      // TODO: Replace with actual subscription API call
      const updatedUser = {
        ...user,
        isSubscribed: true,
        subscribedAt: new Date().toISOString()
      };
      
      localStorage.setItem('user', JSON.stringify(updatedUser));
      setUser(updatedUser);
      setIsSubscribed(true);
      
      return { success: true };
    } catch (error) {
      console.error('Subscription failed:', error);
      return { success: false, error: error.message };
    }
  };

  const value = {
    user,
    isSubscribed,
    loading,
    login,
    signup,
    logout,
    subscribe
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};


